export default __webpack_public_path__ + "static/media/menu-03-statistics-b.25dbda67.svg";